import urlApi from './urlApi';
export var GET_LONG_READ_POST_REQUEST = 'GET_LONG_READ_POST_REQUEST';
export var GET_LONG_READ_POST_SUCCESS = 'GET_LONG_READ_POST_SUCCESS';
export var GET_LONG_READ_POST_ERROR = 'GET_LONG_READ_POST_ERROR';
export var GET_LONG_READ_POST_PAGINATED_REQUEST = 'GET_LONG_READ_POST_PAGINATED_REQUEST';
export var GET_LONG_READ_POST_PAGINATED_SUCCESS = 'GET_LONG_READ_POST_PAGINATED_SUCCESS';
export var GET_LONG_READ_POST_PAGINATED_ERROR = 'GET_LONG_READ_POST_PAGINATED_ERROR';
export function getLongReadPosts(idUser, idLongRead, sign, thematic, rSort) {
    return function (dispatch) {
        dispatch({
            type: GET_LONG_READ_POST_REQUEST,
            payload: {
                lgId: idLongRead
            }
        });
        urlApi()
            .getLongReadPosts(idUser, idLongRead, sign, thematic, rSort)
            .then(function (res) {
            dispatch({
                type: GET_LONG_READ_POST_SUCCESS,
                payload: {
                    data: res.data,
                    lgId: idLongRead
                }
            });
        })
            .catch(function (e) {
            dispatch({
                type: GET_LONG_READ_POST_ERROR,
                payload: {
                    lgId: idLongRead
                }
            });
        });
    };
}
export function getLongReadPostsPaginated(idUser, idLongRead, sign, thematic, rSort, limit, offset, page) {
    return function (dispatch) {
        dispatch({
            type: GET_LONG_READ_POST_PAGINATED_REQUEST,
            payload: {
                lgId: idLongRead,
                page: page,
                limit: limit
            }
        });
        urlApi()
            .getLongReadPostsPaginated(idUser, idLongRead, sign, thematic, rSort, limit, offset, page)
            .then(function (res) {
            dispatch({
                type: GET_LONG_READ_POST_PAGINATED_SUCCESS,
                payload: {
                    data: res.data,
                    lgId: idLongRead,
                    page: page,
                    limit: limit,
                    offset: offset
                }
            });
        })
            .catch(function (e) {
            dispatch({
                type: GET_LONG_READ_POST_PAGINATED_ERROR,
                payload: {
                    lgId: idLongRead,
                    page: page
                }
            });
        });
    };
}
//# sourceMappingURL=getLongReadPosts.js.mapimport urlApi from './urlApi';
export var GET_LONG_READ_POST_REQUEST = 'GET_LONG_READ_POST_REQUEST';
export var GET_LONG_READ_POST_SUCCESS = 'GET_LONG_READ_POST_SUCCESS';
export var GET_LONG_READ_POST_ERROR = 'GET_LONG_READ_POST_ERROR';
export var GET_LONG_READ_POST_PAGINATED_REQUEST = 'GET_LONG_READ_POST_PAGINATED_REQUEST';
export var GET_LONG_READ_POST_PAGINATED_SUCCESS = 'GET_LONG_READ_POST_PAGINATED_SUCCESS';
export var GET_LONG_READ_POST_PAGINATED_ERROR = 'GET_LONG_READ_POST_PAGINATED_ERROR';
export function getLongReadPosts(idUser, idLongRead, sign, thematic, rSort) {
    return function (dispatch) {
        dispatch({
            type: GET_LONG_READ_POST_REQUEST,
            payload: {
                lgId: idLongRead
            }
        });
        urlApi()
            .getLongReadPosts(idUser, idLongRead, sign, thematic, rSort)
            .then(function (res) {
            dispatch({
                type: GET_LONG_READ_POST_SUCCESS,
                payload: {
                    data: res.data,
                    lgId: idLongRead
                }
            });
        })
            .catch(function (e) {
            dispatch({
                type: GET_LONG_READ_POST_ERROR,
                payload: {
                    lgId: idLongRead
                }
            });
        });
    };
}
export function getLongReadPostsPaginated(idUser, idLongRead, sign, thematic, rSort, limit, offset, page) {
    return function (dispatch) {
        dispatch({
            type: GET_LONG_READ_POST_PAGINATED_REQUEST,
            payload: {
                lgId: idLongRead,
                page: page,
                limit: limit
            }
        });
        urlApi()
            .getLongReadPostsPaginated(idUser, idLongRead, sign, thematic, rSort, limit, offset, page)
            .then(function (res) {
            dispatch({
                type: GET_LONG_READ_POST_PAGINATED_SUCCESS,
                payload: {
                    data: res.data,
                    lgId: idLongRead,
                    page: page,
                    limit: limit,
                    offset: offset
                }
            });
        })
            .catch(function (e) {
            dispatch({
                type: GET_LONG_READ_POST_PAGINATED_ERROR,
                payload: {
                    lgId: idLongRead,
                    page: page
                }
            });
        });
    };
}
//# sourceMappingURL=getLongReadPosts.js.map